<template>
<div id="login-box">
    <layout-customs>
        <!-- Page Content -->
        <div class="login-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-5 col-sm-5">
                        <div class="login-left">
                            <h3 class="headline-1 login-title">Welcome to<br> Greeneum Energy<br> Platform</h3>
                            <div>
                              <div class="headline-2 login-title">Your project "{{name}}" is confirmed, Thank you.</div>  
                            </div>
                            <div class="row">
                                  <div class="col-md-8">
                                    <router-link to="/signin" class="btn-w">Goto Sign In Page</router-link>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 col-sm-7">
                        <div class="login-right">
                            <img src="/static/dist/images/login-img.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-customs>
</div>
</template>
<style>
  .btn-w {
    margin-left: 0px !important;
    margin-top: 20px;
  }
  .headline-2.login-title {
    color: white;
  }
</style>
<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
import Api from './../../services/api'

export default {
  name: 'ConfirmProject',
  props: [],
  components: {
    LayoutCustoms,
    Api,
  },
  data() {
    return {
      name: '',
    }
  },
  methods: {   
  },
  async created() {
    var id = this.$route.params.id
   
    var res = await Api.confirmedOwnerProjectById(id)
    this.name = res.data.results
   
  },
 
}
</script>



// WEBPACK FOOTER //
// src/components/Account/ConfirmProject.vue